<div class="search-mobile-wrapper d-flex flex-column" *ngIf="!isHidden" [class.is-open]="isOpen">
  <div class="search-header-block d-flex" (transitionend)="transitionEndHandler($event)">
    <div class="content-box content-box-tertiary-left d-flex pe-0 mx-2">
      <button
        (click)="closeSearchPage()"
        shrdUicButton
        variant="tertiaryMinorBorderless"
        class="m-0 position-absolute close-page-button"
      >
        <shrd-uic-svg-icon icon="cross" size="large" [inheritColor]="true"></shrd-uic-svg-icon>
      </button>
      <shrd-pf-ft-search-input
        class="mobile-search-input"
        iconSize="large"
        [usePreloader]="true"
        [loading]="isLoading$ | async"
        [autofocus]="true"
      ></shrd-pf-ft-search-input>
    </div>
  </div>
  <div
    class="search-results-block opacity-transition"
    [ngClass]="{ 'opacity-0': !isOpen, 'opacity-100': isOpen }"
    shrdPfFtSelectableLinks
    (selectableLinksUpdated)="updateLinkNodes($event)"
  >
    <ng-container *shrdUtcLet="suggestions$ | async as suggestions">
      <ng-container *ngIf="suggestions?.hasValidTerm; else invalidSearchTerm">
        <div class="content-box pt-2 pb-0 px-5 border-bottom border-neutral-light overflow-auto d-flex flex-column">
          <shrd-pf-ft-search-products></shrd-pf-ft-search-products>
          <shrd-pf-ft-search-categories
            class="d-block py-1 mx-n5 px-5 bg-neutral-megalight flex-fill"
          ></shrd-pf-ft-search-categories>
        </div>
        <div class="content-box search-results-block-view-more" *ngIf="suggestions.hasSuggestions">
          <div class="overflow-hidden">
            <a
              shrdUicButton
              variant="tertiaryMinorBorderless"
              [href]="suggestions.searchUrl"
              class="m-0 bl-min-h-5 see-more"
              [shrdUtcTrackEvent]="{
                category: 'ProductInfo',
                action: 'FindProducts',
                label: 'SiteSearchStandard|' + suggestions.term + '|See all results'
              }"
            >
              <shrd-uic-svg-icon icon="arrow-right"></shrd-uic-svg-icon>
              <span>{{ 'header.search.viewAll' | i18next }}</span>
            </a>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #invalidSearchTerm>
      <span class="content-box mt-2 text-center">{{ 'header.search.enterSearchTerm' | i18next }}</span>
    </ng-template>
  </div>
</div>
<button
  (click)="openSearchPage()"
  *ngIf="!isOpen"
  shrdUicButton
  variant="tertiaryMinorBorderless"
  class="m-0 open-search-btn"
  [attr.aria-label]="'header.icon.search' | i18next"
>
  <shrd-uic-svg-icon icon="search" [inheritColor]="true"></shrd-uic-svg-icon>
</button>
